import "./ServicesSection.css";
import rent from "../../assets/images/services/rent.avif";
import progressive from "../../assets/images/services/progressive.avif";
import gaonse from "../../assets/images/services/gaonse.avif";
import farmercitymart from "../../assets/images/services/farmercitymart.avif";
import drone from "../../assets/images/services/drone.avif";
import hire from "../../assets/images/services/hire.avif";

const services = [
  // {
  //   title: "Rent / Lease / Sale",
  //   description:
  //     "Embrace the future of farming with our smart technology. We integrate IoT sensors, drone technology, and digital farm management to optimize irrigation, monitor crop health, and increase your yield. Make data-driven decisions for a more sustainable and profitable farm.",
  //   buttonText: "Learn More",
  //   buttonLink: "all-product",
  //   imageUrl: rent,
  //   imageAlt: "A farmer using a tablet in a green field to manage their crops.",
  //   reverse: false,
  // },
  {
    title: "Progressive Farming Solutions",
    description:
      "Your one-stop marketplace for all agricultural inputs. From high-quality seeds and fertilizers to advanced machinery and animal feed, we provide everything you need with last-mile delivery. Get authentic products at competitive prices, delivered right to your farm gate.",
    buttonText: "Learn More",
    buttonLink: "progressive-farming-solutions",
    imageUrl: progressive,
    imageAlt:
      "Shelves in a store stocked with seeds, fertilizers, and other agricultural inputs.",
    reverse: true,
  },
  {
    title: "Farmer’s City Mart",
    description:
      'Our "Gaon Se" initiative bridges the gap between rural producers and urban consumers. We provide a robust supply chain with cold-chain logistics and real-time pricing, ensuring your produce, dairy, and livestock reach the city market at peak freshness and value.',
    buttonText: "Learn More",
    buttonLink: "farmer-shop",
    imageUrl: farmercitymart,
    imageAlt: "Fresh produce being sold at a vibrant city market stall.",
    reverse: false,
  },
  {
    title: "Gaon Se",
    description:
      "Leverage our cutting-edge drone technology for precision agriculture. Our services include automated crop spraying, field mapping, and health analysis. Improve efficiency, reduce waste of resources like water and pesticides, and get a detailed aerial view of your farm's performance.",
    buttonText: "Learn More",
    buttonLink: "gaon-se",
    imageUrl: gaonse,
    imageAlt:
      "A close-up of an agricultural drone spraying a field with precision.",
    reverse: true,
  },
  {
    title: "Drone Services",
    description:
      "Connect with our team of experienced agronomists for expert advice tailored to your farm. We offer services like soil testing, crop planning, pest management, and financial guidance to help you make informed decisions and overcome agricultural challenges.",
    buttonText: "Learn More",
    buttonLink: "https://droneplanet.in/aboutdaas",
    imageUrl: drone,
    imageAlt:
      "An agricultural expert and a farmer looking at a crop in a field.",
    reverse: false,
  },
  {
    title: "Hire Farm Labour",
    description:
      "Finding reliable and skilled labour can be a challenge. Our platform connects you with a network of trained and vetted farm workers for seasonal or long-term needs. From planting to harvesting, find the right people to support your farm's operations quickly and efficiently.",
    buttonText: "Learn More",
    buttonLink: "hire-farm-labour",
    imageUrl: hire,
    imageAlt: "A group of farm workers harvesting crops in a sunny field.",
    reverse: true,
  },
];

const ServicesComponent = ({
  title,
  description,
  buttonText,
  buttonLink,
  imageUrl,
  imageAlt,
  reverse,
}) => {
  return (
    <section className="service-section-wrapper">
      <div className="service-container">
        <div className={`service-card ${reverse ? "reverse" : ""}`}>
          <div className="service-image">
            <img src={imageUrl} alt={imageAlt} />
          </div>
          <div className="service-content">
            <h2>{title}</h2>
            <p>{description}</p>
            <a href={buttonLink} className="service-button">
              {buttonText}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
const ServicesSection = () => {
  return (
    <section>
      {services.map((service, index) => (
          <ServicesComponent key={index} {...service} />
      ))}
    </section>
  );
};

export default ServicesSection;
